// extracted by mini-css-extract-plugin
export default {"underline":"VectorUnderline_underline__dpexX"};